import { Component, OnInit } from '@angular/core';
import {HtmlUtilsService} from "../html-utils/html-utils.service";
import {Router} from "@angular/router";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {AuthService} from "../auth/auth.service";

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  form!: FormGroup;
  highContrast = false;
  loading = false;
  submitted = false;
  resetPasswordSuccess = false;
  showAlert: boolean = false;

  constructor(private htmlUtils: HtmlUtilsService,
              private route: Router,
              private formBuilder: FormBuilder,
              private authService: AuthService) {
    this.highContrast = this.htmlUtils.contrast;
    this.htmlUtils.highContrast.subscribe((value) => {
      if (value !== this.highContrast) {
        this.highContrast = value;
      }
    });
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      email: new FormControl(
         '',
        [
          Validators.required,
          Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
        ]
      )
    });
  }

  onSubmit() {
    this.submitted = true;

    if (this.form.invalid) {
      return;
    }

    const email = this.formField.email.value.trim();
    this.loading = true;

    this.authService.resetPassword(email).subscribe(
      () => {
        this.showAlert = true;
        this.resetPasswordSuccess = true;
        this.loading = false;
      },
      () => {
        this.showAlert = true;
        this.resetPasswordSuccess = false;
        this.loading = false;
      }
    );
  }

  get formField() {
    return this.form.controls;
  }

  cancel() {
    this.route.navigateByUrl('/login');
  }
}
